export default __webpack_public_path__ + "static/media/main_level_test02_cn.38d97466.png";